interface ZzzfunHeroProps {
  onOpenDownload: () => void;
}

const zzzfunHeroPlatforms = [
  { icon: 'ri-android-fill', label: 'Android' },
  { icon: 'ri-apple-fill', label: 'iOS' },
  { icon: 'ri-smartphone-line', label: 'HarmonyOS' },
  { icon: 'ri-windows-fill', label: 'Windows' },
];

const zzzfunHeroHighlights = [
  { icon: 'ri-trophy-fill', label: '实时排行榜', sub: '热门好番一眼找到' },
  { icon: 'ri-calendar-schedule-line', label: '每日新番时间表', sub: '开播提醒不错过' },
  { icon: 'ri-flashlight-fill', label: '高清无广告', sub: '多端同步追番' },
];

export default function ZzzfunHero({ onOpenDownload }: ZzzfunHeroProps) {
  return (
    <section id="zzzfun-home" className="relative scroll-mt-24 overflow-hidden bg-background-50">
      {/* 背景装饰 */}
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-secondary-100/60 blur-3xl" />

      <div className="relative mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-8">
          {/* 左侧文案 */}
          <div className="zzzfun-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-fire-fill text-sm" />
              以兴趣为核心的番剧播放工具
            </span>

            <h1 className="mt-5 font-display text-6xl font-bold leading-none tracking-tight text-foreground-950 sm:text-7xl md:text-8xl">
              <span className="bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500 bg-clip-text text-transparent">
                ZzzFun
              </span>
            </h1>

            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-3">
              {zzzfunHeroHighlights.map((item) => (
                <div key={item.label} className="flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <span className="text-xs">
                    <span className="block font-bold text-foreground-950">{item.label}</span>
                    <span className="block text-foreground-600">{item.sub}</span>
                  </span>
                </div>
              ))}
            </div>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              ZzzFun聚合海量番剧资源，提供实时排行榜、每日新番时间表与分区发现，支持高清流畅播放与多端同步。无论手机还是电脑，都能随时开启舒适追番之旅。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={onOpenDownload}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                <i className="ri-download-2-line text-xl" />
                立即下载ZzzFun
              </button>
              <a
                href="#zzzfun-features"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-6 py-3.5 text-base font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-play-circle-line text-xl" />
                了解功能
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              {zzzfunHeroPlatforms.map((platform) => (
                <span key={platform.label} className="flex items-center gap-1.5 text-xs text-foreground-600">
                  <i className={`${platform.icon} text-base text-foreground-500`} />
                  {platform.label}
                </span>
              ))}
            </div>
          </div>

          {/* 右侧：移动端首页截图 */}
          <div className="zzzfun-fade-up flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-6 rounded-[3rem] bg-gradient-to-br from-primary-200/50 via-accent-200/40 to-secondary-200/50 blur-2xl" />
              <div className="relative h-[464px] w-[264px] overflow-hidden rounded-[2rem] border-8 border-foreground-900 bg-foreground-900 sm:h-[528px] sm:w-[300px]">
                <img
                  src="/images/zzzfun-app-home.png"
                  alt="ZzzFun动漫APP移动端首页界面"
                  title="ZzzFun官方APP免费下载 - 移动端首页"
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="zzzfun-float absolute -left-6 top-16 hidden items-center gap-2 rounded-xl border border-background-200/70 bg-background-50 px-3 py-2 sm:flex">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
                  <i className="ri-flashlight-fill text-lg" />
                </span>
                <span className="text-xs">
                  <span className="block font-bold text-foreground-950">秒开无广告</span>
                  <span className="block text-foreground-600">高清流畅播放</span>
                </span>
              </div>

              <div className="absolute -bottom-4 -right-3 hidden items-center gap-2 rounded-xl border border-background-200/70 bg-background-50 px-3 py-2 sm:flex">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-refresh-line text-lg" />
                </span>
                <span className="text-xs">
                  <span className="block font-bold text-foreground-950">多端同步</span>
                  <span className="block text-foreground-600">进度云端保存</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}